import { SET_PRODUCTS, SET_PRODUCT, LOADING, SET_PRODUCT_DATA } from './types';

export const actionBuilder = (client, router) => {

  const getProducts = async ({ commit, dispatch }, body = {}) => {
    try {
      commit(LOADING, true);
      const response = await client.getProducts(body);
      commit(SET_PRODUCTS, response.data);

      return true;
    } catch ( error ) {
      await dispatch('processStep/handleError', { response: error.response }, { root: true });

      return false;
    } finally {
      commit(LOADING, false);
    }
  };

  const setProduct = ({ commit }, productName) => {
    commit(SET_PRODUCT, productName);
  };

  const setProductDataFromUrl = ({ commit }) => {
    commit(SET_PRODUCT_DATA, { ...router.currentRoute.query });
  };

  const setProductData = ({ commit }, { amount, period, productName, interestRate, monthlyPayment }) => {
    commit(SET_PRODUCT_DATA, {
      amount,
      period,
      productName,
      interestRate,
      monthlyPayment,
    });
  };

  return {
    getProducts,
    setProduct,
    setProductDataFromUrl,
    setProductData,
  };
};
